@if (pageLayoutBody$ | async; as pageBody) {
<div>
  @for (row of pageBody?.rows; track row; let i = $index) {
  <section [ngClass]="row.styleClass">
    <custom-dot-cms-row [deviceType]="deviceType$ | async" [columns]="row.columns" class="row" />
  </section>
  }
</div>
}
